<template>
    <section style="background-color: #eee;">

        <div class="card" id="chat2">
<!--            <div class="card-header d-flex justify-content-between align-items-center p-3">-->
<!--                <h5 class="mb-0">Chat</h5>-->
<!--                <button type="button" class="btn btn-primary btn-sm" data-mdb-ripple-color="dark">Let's Chat App</button>-->
<!--            </div>-->
            <div ref="chat" class="card-body" data-mdb-perfect-scrollbar="true" style="position: relative; height: 400px; overflow-y: auto; display: flex; flex-direction: column-reverse;">
                <template v-for="(messages,date) in body">
                    <template v-for="m in messages">
                        <Message :message="m" />
                    </template>
                    <div class="divider d-flex align-items-center mb-4">
                        <p class="text-center mx-3 mb-0" style="color: #a2aab7;">{{ date }}</p>
                    </div>
                </template>
            </div>
            <div v-if="$hasPermission('requests.chats.send_message')" class="card-footer text-muted p-3" style="border-top: 2px solid #f5f5f5" v-loading="isLoadingSend">
                <p v-if="last_error" class="text-danger mb-3 mt-3">{{last_error}}</p>
                <el-cascader
                    v-model="params_new_chat"
                    class="w-100" :class="{'mb-3': params_new_chat}"
                    v-if="!chat"
                    placeholder="Выберите параметры нового чата"
                    :options="options">
                </el-cascader>
                <el-upload
                    :ref="'chat_upload_' + _uid"
                    class="chat-upload"
                    action="/api/requests/files/upload"
                    :on-remove="handleFileRemove"
                    :on-success="handleFileSuccess"
                    multiple
                    :limit="10">
                    <el-button :id="'fake_upload_btn_' + _uid"></el-button>
                </el-upload>
                <div v-if="chat || params_new_chat" class="d-flex justify-content-start align-items-center">
                    <a v-if="chat" class="ml-1 text-muted text-xl" @click.prevent="click_upload"><i class="fas fa-paperclip"></i></a>
                    <textarea @keydown="handleEnter" rows="1" class="ml-3 form-control form-control-lg" id="exampleFormControlInput1" placeholder="Написать сообщение..." v-model="send_text"></textarea>
<!--                    <a @click.prevent="emoji = !emoji" class="ml-3 text-xl" :class="{'text-primary': emoji, 'text-muted': !emoji,}" href="#!"><i class="fas fa-smile"></i></a>-->
                    <a @click.prevent="send" class="ml-3 text-xl" :class="{'disabled': !allowSend}" href="#!"><i class="fas fa-paper-plane" :class="{ 'text-primary': allowSend, 'text-muted': !allowSend }"></i></a>
                </div>
<!--                <VEmojiPicker @select="insertEmoji" class="mt-3 w-100" :emojiSize="25" :emojisByRow="12" :emojiWithBorder="false" v-if="emoji" />-->
            </div>
        </div>
    </section>
</template>

<script>
import Message from "./Message";
import { VEmojiPicker } from 'v-emoji-picker';
export default {
    name: "Chat",
    components: {Message, VEmojiPicker},
    props: ['chat', 'request'],
    data: () => ({
        isLoadingSend: false,
        emoji: false,
        messages: [],
        send_files: [],
        send_text: "",
        params_new_chat: null,
        last_error: null,
    }),
    mounted() {
        let self = this;
        if (this.chat) {
            Echo.private('chat.' + this.chat.id)
                .listen('.chat.message.created', function (e) {
                    if (e.message.direction === 'IN') self.$emit('incoming', e.message);
                    self.fetchMessages();
                });
            this.fetchMessages();
        }
    },
    beforeDestroy() {
        if (this.chat) Echo.leave('chat.' + this.chat.id);
    },
    computed: {
        body() {
            return _.groupBy(this.messages, function (m) {
                return moment(m.created_at).format('DD.MM.YYYY');
            })
        },
        allowSend() {
            return this.send_text.length || this.send_files.length;
        },
        options() {
            let options = [];
            let chat_accounts = _.filter(this.$store.getters['auth/user'].chat_accounts, {platform_id: this.request.platform_id});
            let self = this;
            chat_accounts.forEach(function (ac) {
                let label_type = ac.type;
                if (ac.type === 'telegram') label_type = 'Telegram';
                if (ac.type === 'whatsapp2') label_type = 'WhatsApp';
                if (ac.type === 'waba') label_type = 'WhatsApp Business';

                let t = _.find(options, {value: ac.type});
                if (!t) {
                    options.push({
                        value: ac.type,
                        label: label_type,
                        children: [],
                    })
                }
                t = _.find(options, {value: ac.type});

                let phones = [];
                if (self.request.phone) phones.push({value: self.request.phone, label: self.request.phone})
                if (self.request.phone2) phones.push({value: self.request.phone2, label: self.request.phone2})
                if (self.request.phone3) phones.push({value: self.request.phone3, label: self.request.phone3})
                if (self.request.phone4) phones.push({value: self.request.phone4, label: self.request.phone4})
                if (self.request.phone5) phones.push({value: self.request.phone5, label: self.request.phone5})
                if (self.request.phone6) phones.push({value: self.request.phone6, label: self.request.phone6})

                t.children.push({
                    value: ac.id,
                    label: 'аккаунт #' + ac.id,
                    children: phones,
                })
            });
            return options;
        }
    },
    methods: {
        fetchMessages() {
            let self = this;
            axios.get('/api/chats/' + this.chat.id + '/messages')
                .then(r => {
                    self.messages = r.data
                    setTimeout(() => {self.scrollToBottom()}, 1000);
                    setTimeout(() => {self.readMessageBatch()}, 1000);
                })
        },
        readMessageBatch() {
            let self = this;
            axios.post('/api/chats/readBatch', {
                ids: _.map(_.filter(self.messages, {direction: 'IN', was_read: 0}), 'id')
            })
        },
        scrollToBottom() {
            const element = $(this.$refs.chat);
            element.animate({
                scrollTop: element.prop("scrollHeight")
            }, 500);
        },

        click_upload() {
            $('#fake_upload_btn_' + this._uid).click();
        },
        handleFileRemove(file, fileList) {
            this.send_files = fileList
        },
        handleFileSuccess(response, file, fileList) {
            this.send_files = fileList
        },
        handleEnter(e) {
            if (e.keyCode == 13 && !e.shiftKey) {
                e.preventDefault();
                this.send();
            }
        },
        send() {
            if (!this.allowSend) return;
            let self = this;
            this.isLoadingSend = true;
            this.last_error = null;
            if (this.chat) {
                axios.post('/api/chats/' + this.chat.id + '/sendMessage', {
                    text: this.send_text,
                    files: this.send_files,
                })
                    .then(r => {
                        self.send_text = '';
                        self.send_files = [];
                        self.$refs['chat_upload_' + self._uid].clearFiles();
                        self.isLoadingSend = false;
                        if (r.data.error) self.last_error = r.data.error;
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
            if (!this.chat && this.params_new_chat) {
                axios.post('/api/chats/sendFirstMessage', {
                    chat_account_id: this.params_new_chat[1],
                    request_id: this.request.id,
                    destination: this.params_new_chat[2],

                    text: this.send_text,
                    files: this.send_files,
                })
                    .then(r => {
                        self.send_text = '';
                        self.send_files = [];
                        self.$refs['chat_upload_' + self._uid].clearFiles();
                        self.params_new_chat = null


                        self.isLoadingSend = false;
                        if (r.data.error) self.last_error = r.data.error;
                    })
                    .catch(e => {
                        console.log(e);
                    });
            }
        },
    }
}
</script>

<style scoped>

</style>
